enum VariableType {
  EVENT_VARIABLE = 'EventVariable',
  PREVIOUS_EVENT_VARIABLE = 'PreviousEventVariable',
  ACTOR_VARIABLE = 'ActorVariable',
  STREAM_ROW_VARIABLE = 'StreamRowVariable',
  CACHE_VARIABLE = 'CacheVariable',
  DATABASE_VARIABLE = 'DatabaseVariable',
  COMMON_VARIABLE = 'CommonVariable',
  ENTRY_PROPERTIES = 'EntryProperties',
  CUSTOM_EVENT_VARIABLE = 'CustomEventVariable',
  EXPRESSION_VARIABLE = 'ExpressionVariable',
  TOKEN_GROUP = 'TokenGroup',
  CURRENCY = 'Currency',
  DATATABLE_VARIABLE = 'DatatableVariable',
  COLUMN_VARIABLE = 'ColumnVariable',
  HTTP_VARIABLE = 'HttpVariable',
  CONSTANT_VARIABLE = 'ConstantVariable',
  LAMBDA_VARIABLE = 'LambdaVariable',
  QUERY = 'QueryVariable',
  API = 'ApiVariable',
  BASIC = 'BasicVariable',
  LIST = 'ListVariable',
  VELOCITY = 'VelocityVariable',
  ELASTIC_VARIABLE = 'ElasticVariable',
  AI_FEATURE_VARIABLE = 'AiFeatureVariable',
  ML_OPS_VARIABLE = 'MLOpsVariable',
  RESOLUTION_VARIABLE = 'ResolutionVariable',
}

export default VariableType;
